import script from "./VideoIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoIndex.vue?vue&type=script&setup=true&lang=js"

import "./VideoIndex.vue?vue&type=style&index=0&id=d1759ad8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1759ad8"]])

export default __exports__